import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
import {fun_DownloadFile, fun_GetKeys} from "../../../../utils/validate";
import PrintDialog from "../../components/PrintDialog/index.vue";

export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        prjbuildCorpName: null, // 招标人名称
        prjName: null, // 项目名称
        state: null, // 状态
        agencyCorpName: null, // 代理机构名称
        regulators: null, // 行政监督部门
        finalAuditStartTime: null, // 最终核验开始时间
        finalAuditEndTime: null, // 最终核验结束时间
        searchFlag: "0" // 查询标志
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "招标人名称：",
          value: "prjbuildCorpName",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 表格按钮
      btnList: [
        {
          name: "完善备案信息",
          type: "primary",
          icon: "edit"
        },
        {
          type: "slot",
          slotName: "button"
        }
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          isShow: true,
          minWidth: "300",
          fixed: true,
        },
        {
          label: "状态",
          slotName: "state",
          minWidth: "100",
          fixed: true,
        },
        {
          label: "打印",
          slotName: "print",
          minWidth: "130",
          fixed: true,
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          minWidth: "260",
        },
        {
          label: "招标人名称",
          prop: "prjbuildCorpName",
          minWidth: "280",
        },
        {
          label: "项目负责人姓名",
          prop: "prjManName",
          minWidth: "150",
        },
      ],
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text: "（1）招标人：项目名称显示为红色，为该招标人的项目，招标人只能对信息进行查看，无法修改。",
         },
         {
           type: "text",
           text: "（2）招标代理机构：项目名称显示为绿色，为该机构代理的代理项目，代理机构可以进行修改。",
         },
         {
           type: "text",
           text: "（3）完善备案信息：勾选项目名称，点击“完善备案信息”按钮。",
         },
         {
           type: "AdobeReader",
         },*/
       ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // 用户编号
      basicInfoId: null,
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      userType: sessionStorage.getItem("loginType"), // 用户类型
      // 选中的数组
      multipleSelection: []
    }
  },

  components: {
    PrintDialog
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
  },
  // 模板编译完成
  mounted() {
    // 验证身份
    if(this.userFlag == "工作人员" || this.userFlag == "监管人员"){
      // 清空
      this.btnList = [];
    }
    // 获取用户信息
    this.fun_GetUser();
    // 执行获取列表数据方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
    * 获取用户信息
    * @returns {Promise<void>}
    */
    async fun_GetUser() {
      // 请求，获取结果集
      fun_PostAction("/agencyCorpRecords/init", {}).then(res => {
        // 解构res.data
        const { data } = res.data;
        // 设置用户编号
        this.basicInfoId = data.id;
      });
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction("/agencyCorpRecords/list", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "完善备案信息":
          // 编辑的方法
          this.fun_Edit();
          break;
        case "台账":
          // 执行导出的方法
          this.fun_Export();
          break;
      }
    },
    /**
     * 编辑的方法
     */
    fun_Edit() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 操作标识
          let rtn = this.multipleSelection[0].state;
          // 代理单号编号
          let agencyCorpId = this.multipleSelection[0].agencyCorpId;
          // 当前登录用户不是代理单位
          if (agencyCorpId !== this.basicInfoId) {
            // 错误消息提示
            this.$alert(
              "招标人只能进行查看备案信息，无法进行修改！",
              "warning"
            );
            return false;
          }
          // 判断
          if(rtn === "tg"){ // 核验状态为核验通过
            // 验证是否已发招标公告
            this.fun_CheckExistRegistration();
          }else if(rtn === "tj"){
            // 错误消息提示
            this.$alert(
              "该项目信息已提交，无法进行删除或修改操作！",
              "warning"
            );
            return false;
          }else{
            // 跳转详情页面
            this.$router.push({
              path: "/biddingAgencyRecordDetail",
              // 操作类型
              query: {
                id: this.multipleSelection[0].id,
                controllerFlg: "edit"
              }
            });
          }
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 验证是否已发招标公告
     */
    fun_CheckExistRegistration() {
      // 获取keys
      const keys = fun_GetKeys(this.multipleSelection);
      // 发起请求
      fun_GetAction("/tenderRegistration/checkExistRegistration?keys=" + keys).then(res => {
        // 解构res.data
        const { result } = res.data;
        // 操作成功
        if (result) {
          // 错误消息提示
          this.$alert(
            "该招标代理备案已经存在招标登记信息，不能修改!",
            "warning"
          );
        } else {
          // 跳转详情页面
          this.$router.push({
            path: "/biddingAgencyRecordDetail",
            // 操作类型
            query: { id: this.multipleSelection[0].id, controllerFlg: "edit" }
          });
        }
      });
    },
    /**
     * 点击台账的方法
     * @author shuhua
     */
    fun_Export() {
      try {
        // 请求，获取结果集
        fun_Download("/agencyCorpRecords/export", {
          ...this.form,
        }).then(res => {
          // 获取到Content-Disposition;filename
          // 获取头部
          let fileNames = res.headers["content-disposition"];
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          if (fileNames) {
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
            // 关闭加载
            this.loading = false;
          } else {
            // 关闭加载
            this.loading = false;
            // 提示请求失败消息
            this.$message.error("文件不存在！");
          }
        });
      } catch {
      }

    },
    /**
     * 打印的方法
     * @author shuhua
     */
    fun_DialogForPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.agencyCorpId + "," + data.buildCorpId;
      // ids
      this.$refs.printDialog.data = data.id;
      // 权限编号
      this.$refs.printDialog.operationNum = "201606061508000000";
    },
    /**
     * 打印的方法
     */
    fun_DialogPrint(id, agencyCorpId, tender, agencyRecords, bidder, lock, recordNumber) {
        // 根据',' 切割id
        var ids = id.split(",");
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: "agencyCorpRecordsPrint",
        id: ids[0],
        agency: agencyCorpId,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data = new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if(data.size == 0){
          this.$message.success("文件生成中！");
        }else{
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
                  "./static/pdf/web/viewer.html?file=" +
                  encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * @description 进入详情
     * @author
     */
    fun_Details(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/biddingAgencyRecordDetail",
        // 操作类型
        query: { id: e.val.id, controllerFlg: "detail" }
      });
    },
  }
}